import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import {LoginComponent} from "./login.component";
import { SharedModule } from "../shared/shared.module";
import { PasswordUpdateComponent } from './password-update/password-update.component';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  declarations: [
    LoginComponent,
    PasswordUpdateComponent,
    ModalComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule
  ]
})
export class LoginModule { }
